<template>
  <main class="content" v-bind:style="{paddingTop: HEADER_HEIGHT}">
    <SectionFirstScreen/>
    <SectionIcons/>
    <SectionAbout/>
    <SectionFocus/>
    <SectionStatistic/>
    <SectionProjects/>
    <SectionContact/>
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import SectionFirstScreen from "@/components/SectionFirstScreen";
import SectionIcons from "@/components/SectionIcons";
import SectionAbout from "@/components/SectionAbout";
import SectionFocus from "@/components/SectionFocus";
import SectionStatistic from "@/components/SectionStatistic";
import SectionProjects from "@/components/SectionProjects";
import SectionContact from "@/components/SectionContact";
export default {
  components: {
    SectionFirstScreen,
    SectionIcons,
    SectionAbout,
    SectionFocus,
    SectionStatistic,
    SectionProjects,
    SectionContact
  },
  computed: {
    ...mapGetters([
        'HEADER_HEIGHT'
    ])
  },
  methods: {
    ...mapActions([
        'UPDATE_SCROLL',
        'PARALLAX_EF',
        'SEARCH_ANIMATION_ITEMS'
    ]),
    scrolls () {
      this.UPDATE_SCROLL()
    },
    animations () {
      this.SEARCH_ANIMATION_ITEMS()
    },
    parallax () {
      this.PARALLAX_EF()
    }
  },
  mounted() {
    this.scrolls ();
    this.animations ();
    this.parallax ()
  }
}
</script>
<style scoped lang="scss">
// Const
$cRed: #EF3527;
$cBlack: #252525;
$cYellow: #FFA630;
$cWhite: #FFFFFF;
$cGrey: rgba(55, 57, 46, .5);


.content {
}
</style>
